import { render, staticRenderFns } from "./DrillPostListItem.vue?vue&type=template&id=495648d7"
import script from "./DrillPostListItem.vue?vue&type=script&lang=js"
export * from "./DrillPostListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports